import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { skip } from 'rxjs/operators';
import { FormControlBase } from '../dynamic-forms/form-models/form-control-base';
import { DynamicDetailsService } from './dynamic-details.service';

@Component({
  selector: 'hb-dynamic-details-dialog',
  templateUrl: './dynamic-details-dialog.component.html',
  styleUrls: ['./dynamic-details-dialog.component.css'],
})
export class DynamicDetailsDialogComponent implements OnInit, OnDestroy {
  @Input() controls: FormControlBase<any>[] = [];
  @Input() item: any;
  @Output() onSaved: EventEmitter<any> = new EventEmitter();

  detailsValidSub: Subscription;
  isValid: boolean;

  @Input() isReadOnly: boolean;
  @Input() modalTitle: string;

  constructor(private dynamicDetailsService: DynamicDetailsService, private changeDetector: ChangeDetectorRef, public bsModalRef: BsModalRef) {}

  ngOnInit() {
    this.detailsValidSub = this.dynamicDetailsService.detailsChanged.pipe(skip(1)).subscribe(valid => {
      this.isValid = valid;
      this.changeDetector.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.detailsValidSub.unsubscribe();
  }

  close() {
    this.bsModalRef.hide();
  }

  okClick() {
    if (this.isReadOnly) {
      this.close();
    } else {
      this.dynamicDetailsService.saveDetails();
    }
  }

  onDialogSaved() {
    this.onSaved.emit();
  }
}
